import { render, staticRenderFns } from "./Infor.vue?vue&type=template&id=33c869d9&scoped=true&"
import script from "./Infor.vue?vue&type=script&lang=ts&"
export * from "./Infor.vue?vue&type=script&lang=ts&"
import style0 from "./Infor.vue?vue&type=style&index=0&id=33c869d9&scoped=true&lang=css&"
import style1 from "./Infor.vue?vue&type=style&index=1&id=33c869d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c869d9",
  null
  
)

export default component.exports